const POSTHOG_KEY = "phc_wupPeHQEvCoAoKuzAK7UB7j8R6ky68buthykc5GcFwBy";

const POSTHOG_OPTIONS = {
  api_host: "https://us.i.posthog.com",
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  disable_session_recording: true,
  disable_surveys: true,
  advanced_disable_feature_flags: true,
  advanced_disable_decide: true,
  disable_external_dependency_loading: true,
};

let clientPromise: Promise<typeof import("posthog-js").default> | null = null;

export const initAnalytics = () => {
  if (typeof window === "undefined") return Promise.resolve(null);

  if (!clientPromise) {
    clientPromise = import("posthog-js").then(({ default: posthog }) => {
      posthog.init(POSTHOG_KEY, POSTHOG_OPTIONS);
      return posthog;
    });
  }

  return clientPromise;
};

export const scheduleAnalytics = () => {
  if (typeof window === "undefined") return;

  const start = () => {
    if (document.visibilityState !== "visible") return;
    void initAnalytics().catch(() => {});
  };
  const schedule = () => window.setTimeout(start, 3000);

  if (document.readyState === "complete") {
    schedule();
    return;
  }

  window.addEventListener("load", schedule, { once: true });
};

export const track = (event: string, properties?: Record<string, unknown>) => {
  void initAnalytics()
    .then((posthog) => posthog?.capture(event, properties))
    .catch(() => {});
};

export const trackPageview = (path?: string) => {
  if (typeof window === "undefined") return;
  const url = path
    ? `${window.location.origin}${path}`
    : window.location.href;
  void initAnalytics()
    .then((posthog) =>
      posthog?.capture("$pageview", {
        $current_url: url,
        path: path ?? window.location.pathname,
      }),
    )
    .catch(() => {});
};